<template>
  <div style="padding-left: 12px; padding-right: 12px; margin-bottom: 24px">
    <v-row>
      <h1>{{ $t("Select Edition") }}</h1>
    </v-row>
    <v-row>
      {{ $t("Media Hoarder comes in three flavours_") }}
    </v-row>
    <v-row style="color: darkgrey; font-size: 10px;">
      {{ $t("Well, actually, the software is the same in all tiers ;)") }}
    </v-row>
    <v-container>
      <v-row class="text-center">
        <v-col v-for="(plan, i) in plans" :key="i" cols="12" md="4">
          <price-card v-bind="plan" v-on:select="onPlanSelected(plan)" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "SectionPricingPlan",

  components: {
    PriceCard: () => import("@/components/PriceCard")
  },

  provide: {
    heading: { align: "center" }
  },

  data: () => ({
    internalPlans: [
      {
        title: "FREE",
        subtitle:
          "For everyone, especially students and hoarders without a budget_",
        amount: 0,
        // monthly: 10,
        // yearly: 110,
        features: [
          "Enjoy all the features Media Hoarder offers",
          "Manage an unlimited number of movies"
        ]
      },
      {
        title: "PRO",
        subtitle:
          "For everyone who wants to support this project, especially hoarders with a budget_",
        amount: 10,
        // monthly: 39,
        // yearly: 312,
        value: true,
        features: [
          "Enjoy all the features Media Hoarder offers",
          "Manage an unlimited number of movies",
          "$10 less in your pocket"
        ]
      },
      {
        title: "ULTIMATE",
        subtitle:
          "For Apple users_ Did you know that Apple raises yearly fees even for open source projects?",
        amount: 25,
        // monthly: 79,
        // yearly: 632,
        features: [
          "Enjoy all the features Media Hoarder offers",
          "Manage an unlimited number of movies",
          "$10 less in your pocket",
          "another $15 less in your pocket"
        ]
      }
    ],
    interval: 0
  }),

  computed: {
    plans() {
      return this.internalPlans.map(plan => {
        return {
          ...plan,
          // features: this.features,
          // interval: !this.interval ? "Month" : "Year",
          title: plan.title,
          subtitle: plan.subtitle,
          // price: !this.interval ? plan.monthly : plan.yearly
          price: plan.amount
        };
      });
    }
  },

  methods: {
    onPlanSelected(plan) {
      console.log("PricingPlan onPlanSelected plan:", plan);
      this.$emit("plan-selected", plan);
    }
  }
};
</script>
